 <div class="container-fluid">
  <div class="row">
    <app-main-map></app-main-map>
    <mw-cookie-information *ngIf="environment.cookiePermissions"
                           application="'gwm-'+environment.env"
                           (cookieDecision)="cookieDecision($event)"
                           [ignoreStored]="!this.existingCookie"
                           ></mw-cookie-information>
  </div>
</div>


